import {
	AfterViewInit,
	Component,
	ElementRef,
	NgZone,
	OnChanges,
	OnDestroy,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { EnvironmentService } from '@public/src/application/services/environment.service/mod';
import { sharedResolution } from '@public/src/shared_resolution';
import { TermsOfService } from '@view/terms_of_service/terms_of_service.component';
import { createRoot, Root } from 'react-dom/client';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';

const containerElementName = 'reactTermsOfServiceComponent';

@Component({
	standalone: false,
	selector: 'terms-of-service-component',
	template: `
		<semantic-view hideFooter="true">
			<header-component header></header-component>
			<div class="wrapper-container" #${containerElementName}></div>
		</semantic-view>
	`,
	encapsulation: ViewEncapsulation.None,
})
export class TermsOfServiceWrapperComponent implements OnChanges, OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) public containerRef: ElementRef;

	private root: Root;
	private environmentService: EnvironmentService = sharedResolution.resolve(EnvironmentService);

	constructor(private readonly ngZone: NgZone) {}

	ngOnChanges(_: SimpleChanges): void {
		this.render();
	}

	ngAfterViewInit() {
		this.render();
	}

	ngOnDestroy() {
		this.root?.unmount();
	}

	private render() {
		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper>
					<TermsOfService baseUrl={this.environmentService.hosting.location} />
				</CellulaProviderWrapper>,
			);
		});
	}
}
